import './app.css'
import Accordion from "./components/Accordion"
import {useEffect , useState , useRef} from "react"
import {io} from "socket.io-client"
import socket from './../socket.js'

import {useNavigate} from "react-router-dom";
import Switch from "./components/Switch"
import SendData from "./SendData"

import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';


import Home from "./Home";
import GetPhone from "./GetPhone";
import GetCode from "./GetCode";
import MainApp from "./MainApp";
import MainSetting from "./MainSetting";
import SystemSetting from "./SystemSetting";
import NameSetting from "./NameSetting";
import ConfigSetting from "./ConfigSetting";
import WindowSetting from "./WindowSetting";
import MandatorySetting from "./MandatorySetting";
import ErrorSetting from "./ErrorSetting";
import PhoneSetting from "./PhoneSetting";
import TimeSetting from "./TimeSetting";
import MenuTimeSetting from "./MenuTimeSetting";

const SERVER_URL='http://hooshsabz.ir:4002';



function MainRoute () {
  const [status,setStatus] = useState ("disconnected");
  const [data,setData] = useState (null);
  const navigate = useNavigate ();

  const id=localStorage.getItem ('id');
  const phone=localStorage.getItem ('phone');
  const boards=JSON.parse(localStorage.getItem ('boards'));
  const select_board=localStorage.getItem ('select_board');
  //const socket =  io(); //useRef (null);

  useEffect (()=>{

//    socket.current=io(SERVER_URL,{transports:['websocket'],reconnectionAttempts:5,timeout:4000});
  //  if (!socket)return;
//    socket.current.on ('connect',()=>{
  //    setStatus ("connected")
//      socket.current.emit ('myPhone',{"phone":'09133337058'});
//    });
//    socket.current.on ('disconnect',()=>setStatus ("disconnected"));
//    socket.current.on ('message',(data)=>{
  //    setData (data);
//    });
/*    if (id!=null && phone!=null && boards!=null && select_board!=null)
      navigate ('/MainApp')
    else
      navigate ('/GetPhone');
      */
      navigate ('/Home');
  //    navigate ('/MainApp');
  },[]);


  return(
    <div>
      <Routes>
        <Route path="/Home" element={<Home/>} />
        <Route path="/GetPhone" element={<GetPhone/>} />
        <Route path="/GetCode" element={<GetCode/>} />
        <Route path="/MainApp" element={<MainApp/>} />

        <Route path="/MainSetting" element={<MainSetting/>} />
        <Route path="/SystemSetting" element={<SystemSetting/>} />
        <Route path="/NameSetting" element={<NameSetting/>} />
        <Route path="/ConfigSetting" element={<ConfigSetting/>} />
        <Route path="/PhoneSetting" element={<PhoneSetting/>} />
        <Route path="/ErrorSetting" element={<ErrorSetting/>} />
        <Route path="/WindowSetting" element={<WindowSetting/>} />
        <Route path="/MandatorySetting" element={<MandatorySetting/>} />
        <Route path="/TimeSetting" element={<TimeSetting/>} />
        <Route path="/MenuTimeSetting" element={<MenuTimeSetting/>} />

      </Routes>
    </div>
  );

}
export default MainRoute;
